import { createSelector } from "@reduxjs/toolkit";

import { dataSelector } from "./helpers";
import { IDataKeys } from "shared/types";
import { buildData, dataMetaSelectorHelper } from "Bands/state";
import { IBandInvitation } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { buildSingleItem } from "shared/utils";

export const pendingBandInvitationsSelector = createSelector(
  dataSelector,
  (data) =>
    (buildData(data as any, IDataKeys.pendingBandInvitation) ||
      []) as IBandInvitation[]
);

export const sentBandInvitationsSelector = createSelector(
  dataSelector,
  (data) =>
    (buildData(data as any, IDataKeys.sentBandInvitation) ||
      []) as IBandInvitation[]
);

const bandInvitationSelector = createSelector(
  dataSelector,
  (data) => data.bandInvitation
);
export const bandInvitationSelectorCreator = (id: string) =>
  createSelector(bandInvitationSelector, (bandInvitations) => {
    let invite = null;
    if (bandInvitations && Object.values(bandInvitations).length === 1) {
      invite = Object.values(bandInvitations)[0];
    } else {
      invite = bandInvitations?.[API_ENDPOINTS.BAND_INVITATION(id)];
    }

    if (invite) {
      return buildSingleItem(invite) as IBandInvitation;
    }
    return null;
  });

export const bandInvitationMetaSelector = (id: string) =>
  dataMetaSelectorHelper(API_ENDPOINTS.BAND_INVITATION(id));
